export default {
  GBP: {
    group: {
      week: '5.95',
    },
    nonMember: {
      single: '3.99',
      annual: '24.99',
      magazine: '4.99',
    },
  },
  EUR: {
    group: {
      week: '10',
    },
    nonMember: {
      single: '4.49',
      annual: '27.99',
    },
  },
};
